import { api } from './api'

export const authApi = api.injectEndpoints({
    endpoints: (builder) => ({
        signup: builder.mutation({
            query(data) {
                return {
                    url: 'auth/signup',
                    method: 'POST',
                    body: data,
                }
            },
        }),
        login: builder.mutation({
            query(data) {
                return {
                    url: 'auth/login',
                    method: 'POST',
                    body: data,
                }
            },
        }),
        logout: builder.mutation({
            query(data) {
                return {
                    url: 'auth/logout',
                    method: 'POST',
                    body: data,
                }
            },
        }),
        refreshToken: builder.mutation({
            query(data) {
                return {
                    url: 'auth/refresh',
                    method: 'POST',
                    body: data,
                }
            },
        }),
    }),
})

export const {
    useSignupMutation,
    useLoginMutation,
    useLogoutMutation,
    useRefreshTokenMutation,
} = authApi
